module.exports = __webpack_public_path__ + "img/fr_Logo_OVT.c4cc14e7.png";